import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import OnePost from "../ones/OnePost";
import { MdAutoAwesome, MdPhotoLibrary } from "react-icons/md";

export default function PostsFeed(props) {

  const appContext = useContext(AppContext);

  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);

    try {
      await appContext.getPostsFeed();
    } catch (e) {
      // keep silent; appContext likely handles errors
    }

    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])

  function renderEmptyState() {
    return (
      <div
        className="mShadow3"
        style={{
          borderRadius: "26px",
          background: "rgba(244,244,244,0.80)",
          backdropFilter: "blur(14px)",
          WebkitBackdropFilter: "blur(14px)",
          border: "1px solid rgba(0,0,0,0.06)",
          overflow: "hidden",
          padding: "20px",
          textAlign: "center",
        }}
      >
        <div
          className="mShadow1"
          style={{
            width: "64px",
            height: "64px",
            borderRadius: "24px",
            background: "rgba(255,255,255,0.6)",
            border: "1px solid rgba(0,0,0,0.06)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            marginBottom: "12px",
          }}
        >
          <MdAutoAwesome className="text-primary" size={28} />
        </div>

        <h6 className="font-semi-bold mNoMargin" style={{ fontSize: "16px" }}>
          No posts yet
        </h6>

        <p
          className="font-regular"
          style={{
            marginTop: "8px",
            marginBottom: 0,
            fontSize: "13px",
            opacity: 0.75,
            lineHeight: "18px",
          }}
        >
          Be the first to share a message or a photo with the community.
        </p>
      </div>
    )
  }

  if (ready) {

    const posts = appContext.postsFeed || [];

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
          paddingTop: "20px",
          paddingBottom: "calc(var(--topBarHeight) + 40px)",
        }}
        className="mNoScrollBar"
      >
        <div className="container">
          <div className="row">

            <div className="col-md-12">
              <h6 className="main-section-title" style={{ marginBottom: "16px" }}>
                Posts
              </h6>
            </div>

            <div className="col-md-12">
              {
                (posts && posts.length > 0) ?
                  posts.map((p, i) => (
                    <OnePost
                      key={(p.uuid) ? p.uuid : i}
                      post={p}
                    />
                  ))
                  :
                  renderEmptyState()
              }
            </div>

          </div>
        </div>
      </div>
    )

  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }

}
